import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { Select, SelectItem, SelectedItems } from '@backstage/core-components';
import { C4DiagramEntity } from '../C4DiagramCard/types';
import { Checkbox, FormControlLabel } from '@material-ui/core';

interface DialogAddProps {
  open: boolean;
  components: Array<C4DiagramEntity>;
  onClose: () => void;
  onSave: (id: string) => void;
}

export function DialogAdd({
  open,
  components,
  onClose,
  onSave,
}: Readonly<DialogAddProps>) {
  const [component, setComponent] = useState<SelectedItems>('');
  const [items, setItems] = useState<SelectItem[]>([]);
  const [filter, setFilter] = useState(true);

  useEffect(() => {
    initItems(filter);
  }, [components]);

  function initItems(withFilter: boolean) {
    const filtered = components
      .filter(it => !it.system || !withFilter)
      .map(it => {
        return { label: `[${it.type}] ${it.text!}`, value: it.id };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    setItems(filtered);
    setComponent(filtered && filtered.length > 0 ? filtered[0].value : '');
  }

  function handleFilter(e: ChangeEvent<HTMLInputElement>) {
    setFilter(e.target.checked);
    initItems(e.target.checked);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add existing component</DialogTitle>
      <DialogContent>
        <FormControlLabel
          label="Show only components without a system"
          control={
            <Checkbox checked={filter} onChange={handleFilter}></Checkbox>
          }
        ></FormControlLabel>
        <Select
          label="Component"
          items={items}
          onChange={(e: SelectedItems) => {
            setComponent(e);
          }}
          multiple={false}
          selected={component}
        ></Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onSave(component as string)}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
